import { render, staticRenderFns } from "./BlocksCrud.vue?vue&type=template&id=57d99920&scoped=true&"
import script from "./BlocksCrud.vue?vue&type=script&lang=js&"
export * from "./BlocksCrud.vue?vue&type=script&lang=js&"
import style0 from "./BlocksCrud.vue?vue&type=style&index=0&id=57d99920&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57d99920",
  null
  
)

export default component.exports